/**
 * Enum for payable status
 * @enum {string}
 * @readonly
 */

export const PayableStatus = Object.freeze({
  PAYABLE: 'PAYABLE',
  PARTIALLY_PAYABLE: 'PARTIALLY_PAYABLE',
  NOT_PAYABLE: 'NOT_PAYABLE',
});
